const ENGAGE_BASE = '/dashboard/engage';
const VOICE_BASE = '/dashboard/voice';
const AI_TOOLS_BASE = '/dashboard/ai-tools';
const AI_CREDENTIALS_BASE = `${AI_TOOLS_BASE}/credentials`;

/** Relative paths for nested routes within /dashboard/engage/* */
export const engageNestedRoutes = {
  AUTOMATIONS_EDIT: 'automations/edit/:automation-id',
  SEGMENTS_NEW: 'segments/new',
  SEGMENTS_EDIT: 'segments/edit/:canonicalVersionId',
} as const;

export const appRoutes = {
  ENGAGE_SETUP: ENGAGE_BASE,
  ENGAGE_AUTOMATIONS: `${ENGAGE_BASE}/automations`,
  ENGAGE_AUTOMATIONS_EDIT: `${ENGAGE_BASE}/${engageNestedRoutes.AUTOMATIONS_EDIT}`,
  ENGAGE_SEGMENTS: `${ENGAGE_BASE}/segments`,
  ENGAGE_SEGMENTS_NEW: `${ENGAGE_BASE}/${engageNestedRoutes.SEGMENTS_NEW}`,
  ENGAGE_SEGMENTS_EDIT: `${ENGAGE_BASE}/${engageNestedRoutes.SEGMENTS_EDIT}`,
  VOICE: VOICE_BASE,
  AI_TOOLS: AI_TOOLS_BASE,
  AI_TOOL_NEW: `${AI_TOOLS_BASE}/new`,
  AI_TOOL_EDIT: `${AI_TOOLS_BASE}/:id`,
  AI_CREDENTIALS: AI_CREDENTIALS_BASE,
} as const;

export const buildAiToolEditPath = (id: string): string => appRoutes.AI_TOOL_EDIT.replace(':id', id);

/** Build navigation path by replacing :automation-id param */
export const buildAutomationEditPath = (automationId: string): string =>
  appRoutes.ENGAGE_AUTOMATIONS_EDIT.replace(':automation-id', automationId);

/** Build navigation path by replacing :canonicalVersionId param */
export const buildSegmentEditPath = (canonicalVersionId: string): string =>
  appRoutes.ENGAGE_SEGMENTS_EDIT.replace(':canonicalVersionId', canonicalVersionId);
